import appGlobalScript from '/usr/src/git2rpm/root-896c4d59-a20e-49af-b38b-1baf64838a2a/tmp/topdir/BUILD/townnews-webcomponent-1.26.0/src/global/app.ts';
export const globalScripts = appGlobalScript;
